import React from 'react';
import ConfirmModal from '../../common/ConfirmModal';

export default function ModalCreateNewVersion({ show, onClose, onConfirm }) {
  return (
    <ConfirmModal
      show={show}
      onClose={onClose}
      onConfirm={onConfirm}
      headerText="Создание версии ЦП"
      message="При сохранении будет создана новая версия Цифрового паспорта проекта, статус будет изменен на «Черновик». Сохранить изменения?"
    />
  );
}
